/**
 * @generated SignedSource<<7e95fa1a58b9d404815d6560c5e71040>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCard_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_viewer">;
  readonly " $fragmentType": "CheckoutCreditCard_viewer";
};
export type CheckoutCreditCard_viewer$key = {
  readonly " $data"?: CheckoutCreditCard_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCard_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCard_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1e834750b4910bdfa531b0eb3aec2860";

export default node;
